import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BadgeCounterComponent } from "./badge-counter.component";

@NgModule({
    imports: [CommonModule],
    declarations: [BadgeCounterComponent],
    exports: [BadgeCounterComponent]
}
)
export class BadgeCounterModule {}